/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountsPayableAuditLogActivity,
  ApprovalStepActivity,
  ApprovalStepActivityV2,
  BatchUploadRequestSupplierAccountRequestDto,
  BatchUploadReviewSuppliersPayload,
  BulkDeleteSuppliersRequest,
  CommentActivity,
  CsvReviewResponseSupplierAccountRequestDto,
  ExportEventActivity,
  ExternalActionActivityV2,
  GetAllPagedByOrganisationParams,
  GetSuppliersIdsByOrganisationWithoutPaginationParams,
  InfiniteScrollListSupplierAccountResponseObject,
  PaymentActivity,
  PullAccountingAttributesRequest,
  StatusChangeActivity,
  SupplierAccountDto,
  SupplierAccountEmployeeUpdateRequestDto,
  SupplierAccountRequest,
  SupplierAccountResponse,
  SupplierAccountSlim,
  SupplierComplianceValidationExemptRequestDto,
  SupplierRecipientRequest,
  SupplierRecipientResponse,
  SuppliersBulkSyncRequest,
  SuppliersBulkUpdateRequest,
  SystemActionActivityV2,
  SystemPaymentActionActivityV2,
  UserActionActivity,
  UserActionActivityV2,
  UserFieldChangeActivity,
  VerificationStepActivityV2,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSupplierAccountV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name MarkComplianceValidationExempt
   * @request PUT:/api/v2/supplier-account/{supplierAccountId}/mark-compliance-validation-exempt
   */
  markComplianceValidationExempt = (
    supplierAccountId: string,
    data: SupplierComplianceValidationExemptRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v2/supplier-account/${supplierAccountId}/mark-compliance-validation-exempt`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static markComplianceValidationExemptPath =
    '/v2/supplier-account/${supplierAccountId}/mark-compliance-validation-exempt'
  static markComplianceValidationExemptMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name AddMissingBicToSupplierAccount
   * @request PUT:/api/v2/supplier-account/update-missing-bic/{supplierAccountId}
   */
  addMissingBicToSupplierAccount = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<SupplierAccountDto, any>({
      path: `/v2/supplier-account/update-missing-bic/${supplierAccountId}`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static addMissingBicToSupplierAccountPath =
    '/v2/supplier-account/update-missing-bic/${supplierAccountId}'
  static addMissingBicToSupplierAccountMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name RemoveSupplierEmployeeMappingBySupplierAccountId
   * @request PUT:/api/v2/supplier-account/remove-employee-mapping/supplierAccountId/{supplierAccountId}
   */
  removeSupplierEmployeeMappingBySupplierAccountId = (
    supplierAccountId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountDto, any>({
      path: `/v2/supplier-account/remove-employee-mapping/supplierAccountId/${supplierAccountId}`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static removeSupplierEmployeeMappingBySupplierAccountIdPath =
    '/v2/supplier-account/remove-employee-mapping/supplierAccountId/${supplierAccountId}'
  static removeSupplierEmployeeMappingBySupplierAccountIdMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name RemoveSupplierEmployeeMappingByOrganisationAndEmployeeId
   * @request PUT:/api/v2/supplier-account/remove-employee-mapping/employeeId/{organisationId}/{employeeId}
   */
  removeSupplierEmployeeMappingByOrganisationAndEmployeeId = (
    organisationId: string,
    employeeId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountDto, any>({
      path: `/v2/supplier-account/remove-employee-mapping/employeeId/${organisationId}/${employeeId}`,
      method: 'PUT',
      format: 'json',
      ...params,
    })

  static removeSupplierEmployeeMappingByOrganisationAndEmployeeIdPath =
    '/v2/supplier-account/remove-employee-mapping/employeeId/${organisationId}/${employeeId}'
  static removeSupplierEmployeeMappingByOrganisationAndEmployeeIdMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name CreateSupplierAccount
   * @request POST:/api/v2/supplier-account
   */
  createSupplierAccount = (data: SupplierAccountRequest, params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v2/supplier-account`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSupplierAccountPath = '/v2/supplier-account'
  static createSupplierAccountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetById
   * @request GET:/api/v2/supplier-account/{supplierAccountId}
   */
  getById = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v2/supplier-account/${supplierAccountId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v2/supplier-account/${supplierAccountId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name UpdateSupplierAccount
   * @request POST:/api/v2/supplier-account/{supplierAccountId}
   */
  updateSupplierAccount = (
    supplierAccountId: string,
    data: SupplierAccountRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v2/supplier-account/${supplierAccountId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSupplierAccountPath = '/v2/supplier-account/${supplierAccountId}'
  static updateSupplierAccountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name DeleteSupplierAccount
   * @request DELETE:/api/v2/supplier-account/{supplierAccountId}
   * @deprecated
   */
  deleteSupplierAccount = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/supplier-account/${supplierAccountId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteSupplierAccountPath = '/v2/supplier-account/${supplierAccountId}'
  static deleteSupplierAccountMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name UpdateSupplierAndRecipient
   * @request POST:/api/v2/supplier-account/{supplierAccountId}/update-supplier-and-recipient
   */
  updateSupplierAndRecipient = (
    supplierAccountId: string,
    data: SupplierRecipientRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierRecipientResponse, any>({
      path: `/v2/supplier-account/${supplierAccountId}/update-supplier-and-recipient`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSupplierAndRecipientPath =
    '/v2/supplier-account/${supplierAccountId}/update-supplier-and-recipient'
  static updateSupplierAndRecipientMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name PullAttributesFromSourceOrganisation
   * @request POST:/api/v2/supplier-account/pull-from-other-org
   */
  pullAttributesFromSourceOrganisation = (
    data: PullAccountingAttributesRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/supplier-account/pull-from-other-org`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static pullAttributesFromSourceOrganisationPath = '/v2/supplier-account/pull-from-other-org'
  static pullAttributesFromSourceOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name CreateSupplierAndRecipient
   * @request POST:/api/v2/supplier-account/create-supplier-and-recipient
   */
  createSupplierAndRecipient = (data: SupplierRecipientRequest, params: RequestParams = {}) =>
    this.http.request<SupplierRecipientResponse, any>({
      path: `/v2/supplier-account/create-supplier-and-recipient`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSupplierAndRecipientPath = '/v2/supplier-account/create-supplier-and-recipient'
  static createSupplierAndRecipientMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name BulkUpdateSuppliers
   * @request POST:/api/v2/supplier-account/bulk-update
   */
  bulkUpdateSuppliers = (data: SuppliersBulkUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/supplier-account/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateSuppliersPath = '/v2/supplier-account/bulk-update'
  static bulkUpdateSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name BulkTriggerSuppliersSync
   * @request POST:/api/v2/supplier-account/bulk-sync
   */
  bulkTriggerSuppliersSync = (data: SuppliersBulkSyncRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/supplier-account/bulk-sync`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkTriggerSuppliersSyncPath = '/v2/supplier-account/bulk-sync'
  static bulkTriggerSuppliersSyncMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name BulkDeleteInvoices
   * @request POST:/api/v2/supplier-account/bulk-delete
   * @deprecated
   */
  bulkDeleteInvoices = (data: BulkDeleteSuppliersRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/supplier-account/bulk-delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkDeleteInvoicesPath = '/v2/supplier-account/bulk-delete'
  static bulkDeleteInvoicesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name BatchUploadSuppliers
   * @request POST:/api/v2/supplier-account/batch-upload
   */
  batchUploadSuppliers = (
    data: BatchUploadRequestSupplierAccountRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/supplier-account/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadSuppliersPath = '/v2/supplier-account/batch-upload'
  static batchUploadSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name BatchUploadReviewSuppliers
   * @request POST:/api/v2/supplier-account/batch-upload/review
   */
  batchUploadReviewSuppliers = (
    data: BatchUploadReviewSuppliersPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvReviewResponseSupplierAccountRequestDto, any>({
      path: `/v2/supplier-account/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewSuppliersPath = '/v2/supplier-account/batch-upload/review'
  static batchUploadReviewSuppliersMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name UpdateSupplierAccounting
   * @request POST:/api/v2/supplier-account/accounting/{supplierAccountId}
   */
  updateSupplierAccounting = (
    supplierAccountId: string,
    data: SupplierAccountRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v2/supplier-account/accounting/${supplierAccountId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSupplierAccountingPath = '/v2/supplier-account/accounting/${supplierAccountId}'
  static updateSupplierAccountingMethod = 'POST'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name UpdateEmployee
   * @request PATCH:/api/v2/supplier-account/{supplierAccountId}/employee
   */
  updateEmployee = (
    supplierAccountId: string,
    data: SupplierAccountEmployeeUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SupplierAccountDto, any>({
      path: `/v2/supplier-account/${supplierAccountId}/employee`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateEmployeePath = '/v2/supplier-account/${supplierAccountId}/employee'
  static updateEmployeeMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetSupplierAndRecipientBySupplierId
   * @request GET:/api/v2/supplier-account/{supplierAccountId}/supplier-and-recipient
   */
  getSupplierAndRecipientBySupplierId = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<SupplierRecipientResponse, any>({
      path: `/v2/supplier-account/${supplierAccountId}/supplier-and-recipient`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSupplierAndRecipientBySupplierIdPath =
    '/v2/supplier-account/${supplierAccountId}/supplier-and-recipient'
  static getSupplierAndRecipientBySupplierIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetSupplierAccountActivityLog
   * @request GET:/api/v2/supplier-account/{supplierAccountId}/change-log
   */
  getSupplierAccountActivityLog = (supplierAccountId: string, params: RequestParams = {}) =>
    this.http.request<
      (
        | AccountsPayableAuditLogActivity
        | ApprovalStepActivity
        | ApprovalStepActivityV2
        | CommentActivity
        | ExportEventActivity
        | ExternalActionActivityV2
        | PaymentActivity
        | StatusChangeActivity
        | SystemActionActivityV2
        | SystemPaymentActionActivityV2
        | UserActionActivity
        | UserActionActivityV2
        | UserFieldChangeActivity
        | VerificationStepActivityV2
      )[],
      any
    >({
      path: `/v2/supplier-account/${supplierAccountId}/change-log`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSupplierAccountActivityLogPath = '/v2/supplier-account/${supplierAccountId}/change-log'
  static getSupplierAccountActivityLogMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetSupplierAccountsSlim
   * @request GET:/api/v2/supplier-account/slim
   */
  getSupplierAccountsSlim = (params: RequestParams = {}) =>
    this.http.request<SupplierAccountSlim[], any>({
      path: `/v2/supplier-account/slim`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSupplierAccountsSlimPath = '/v2/supplier-account/slim'
  static getSupplierAccountsSlimMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetAllByOrganisation
   * @request GET:/api/v2/supplier-account/organisation
   * @deprecated
   */
  getAllByOrganisation = (params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse[], any>({
      path: `/v2/supplier-account/organisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllByOrganisationPath = '/v2/supplier-account/organisation'
  static getAllByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetAllPagedByOrganisation
   * @request GET:/api/v2/supplier-account/organisation/paged
   */
  getAllPagedByOrganisation = (
    query: GetAllPagedByOrganisationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListSupplierAccountResponseObject, any>({
      path: `/v2/supplier-account/organisation/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllPagedByOrganisationPath = '/v2/supplier-account/organisation/paged'
  static getAllPagedByOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetSuppliersIdsByOrganisationWithoutPagination
   * @request GET:/api/v2/supplier-account/organisation/all/ids
   */
  getSuppliersIdsByOrganisationWithoutPagination = (
    query: GetSuppliersIdsByOrganisationWithoutPaginationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v2/supplier-account/organisation/all/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSuppliersIdsByOrganisationWithoutPaginationPath =
    '/v2/supplier-account/organisation/all/ids'
  static getSuppliersIdsByOrganisationWithoutPaginationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-supplier-account-v-2-controller
   * @name GetByEmployeeId
   * @request GET:/api/v2/supplier-account/employee/{employeeId}
   */
  getByEmployeeId = (employeeId: string, params: RequestParams = {}) =>
    this.http.request<SupplierAccountResponse, any>({
      path: `/v2/supplier-account/employee/${employeeId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByEmployeeIdPath = '/v2/supplier-account/employee/${employeeId}'
  static getByEmployeeIdMethod = 'GET'
}
